<template>
<div style="width:1300px;margin:0 auto;padding:80px 0 0px 0;margin-bottom:60px;position:relative;color:#fff;cursor:pointer" @click="goMore">
  <div class="titleStyle" :style="titleStyle">
    <span style="font-size:97px;font-weight:700">{{newsInfo.sub_name}}</span>
  </div>
  <img src="@/views/solution/images/redRight.png" alt="" srcset="" style="width:23px;position:absolute;top:35px;left:265px">
  <div style="position:absolute;display:block;bottom:0px;font-size:18px;letter-spacing:1px;font-weight:300;left:265px;border-bottom:1px solid #3f4354;padding-bottom:5px;width:1060px;">
    <span style="color:#fcfcfc;">新闻资讯</span>
     <span style="display:block;float:right;font-weight:200;color:#fcfcfc">+ MORE</span>
  </div>
</div>
</template>
<script>
export default {
  name: 'App',
   components:{
 
  },
  props: {
    newsInfo:{
      type: Object,
      default: function() {
        return {}
      }
    },
    id: {
      type: Number,
      default: 18
    },
    titleStyle: {
      type: String,
      default: ''
    },
    subTitleStyle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'News'
    },
    subTitle: {
      type: String,
      default: '新闻咨询'
    }
  },
  data() {  
    return {  
     images: [  
       
      ] 
    };  
  }, 

  methods:{
    goMore() {
      this.$router.push({ path: '/news' ,query:{id:this.newsInfo.id,type:'article'}})
    },
  }
}
</script>
<style lang="scss" scoped>
.titleStyle {
  height:100%;display:inline-block;width:390px;
}
.subTitleStyle {
  position:relative;display:inline-block;width:910px;height:95px;border-bottom:1px solid #000;
}
</style>
